<template>
  <div>
    <div class="filters">
      <div class="filters__left">
        <div class="filters__item">
          <icon-department size="18" class="department-icon"></icon-department>
          <div class="filters__title">Центр:_</div>
          <el-select
              @change="loadVisitList(1)"
              class="filters__department"
              v-model="search.departmentId"
              v-loading="loadDepartment"
              placeholder="Название учреждения"
              name="department"
          >
            <el-option
                v-for="item in departmentList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>

    <div class="filters">

      <div class="filters__left">
        <div class="filters__item">
          <div class="filters__title">Поиск:</div>
          <el-input
              @change="loadVisitList(1)"
              name="phone"
              ref="phone"
              v-model="search.phone"
              v-mask="'+7-xxx-xxx-##-##'"
              placeholder="Номер телефона (4 цифры)..."
              auto-complete="off"
              class="filters__phone"
              suffix-icon="el-icon-search"
              clearable
          ></el-input>
          <div class="filters__title">Поиск:</div>
          <el-input
              @change="loadVisitList(1)"
              v-model="search.id"
              class="filters__id"
              placeholder="ID..."
              auto-complete="off"
              suffix-icon="el-icon-search"
              clearable
          ></el-input>
        </div>

      </div>
      <div class="filters__right">
        <div class="filters__title">Статус:</div>
        <el-select
            class="filters__status"
            @change="loadVisitList(1)"
            v-model="search.inspectionStatus"
            placeholder="Статус визита"
        >
          <el-option
              v-for="item in inspectionStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>


    <div v-loading="loading">

      <div class="" v-if="isShowVisit">

        <el-table
            :data="visitsList"
            class="zebra-table"
            @row-click="goVisit"
            style="width: 100%">
          <el-table-column
              label="Клиент"
          >

            <template slot-scope="scope">

              <div class="user-list-item__left left-panel">
                <div class="left-panel__user user-data">
                  <div class="user-data__photo" v-if="scope.row.user">
                    <letters-avatar v-if="scope.row.user.name" :name="scope.row.user.name" type="mini"/>
                  </div>
                  <div class="user-data__info info-user" v-if="scope.row.user">
                    <div class="info-user__name" v-if="scope.row.user.name">{{ scope.row.user.name }}
                      <span class="info-user__name_mini">ID: {{ scope.row.user.id }}</span>
                    </div>
                    <div class="info-user__phone" v-if="scope.row.user.phone">{{ scope.row.user.phone }}</div>
                  </div>
                </div>
              </div>

            </template>

          </el-table-column>
          <el-table-column
              prop="status"
              label="Дата обновления"
              align="left"
          >
            <template slot-scope="scope">
              <i class="el-icon-date"></i> {{ $root.dateDefault(scope.row.date_end) }}
            </template>
          </el-table-column>
          <el-table-column
              label="Специалист"
              align="left"
          >
            <template slot-scope="scope">
              <i class="el-icon-user"></i> {{ scope.row.department.title }}
            </template>
          </el-table-column>
          <el-table-column
              prop="status"
              label="Центр"
          >
            <template slot-scope="scope">
              <div style="display: flex; align-items: center;">
                <icon-department size="18" class="department-icon"></icon-department>
                {{ scope.row.department.title }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="status"
              label="Статус"
              align="left"
              width="100"
          >
            <template slot-scope="scope">
              <div style="display: flex; align-items: center;">
                <i class="el-icon-edit-outline"></i> {{ scope.row.inspection_status_text }}
              </div>
            </template>
          </el-table-column>

        </el-table>


        <el-pagination
            v-if="showPagination"
            class="pagination"
            background
            layout="prev, pager, next"
            :page-size="pagination.per_page"
            :total="pagination.total"
            :current-page="pagination.current_page"
            @current-change="loadVisitList"
        />
      </div>
      <el-alert
          v-else
          :closable="false"
          title="Отсутствует список найденных визитов"
          type="info">
      </el-alert>

    </div>

  </div>

</template>

<script>import Vue from "vue"
import VueMask from "v-mask"

import IconDepartment from "@/components/icons/department.vue"
import LettersAvatar from "@/components/elements/LettersAvatar";

Vue.use(VueMask)

export default {
  name: "HeatMarker.List",
  components: {IconDepartment, LettersAvatar},
  data() {
    return {
      visitsList: [],
      loading: false,
      loadDepartment: false,
      pagination: null,
      search: {
        departmentId: 0,
        inspectionStatus: null,
        phone: null,
        id: null,
      },
      filters: {
        time: 'desc'
      },
      departmentList: {},
      value: "",
      inspectionStatus: [
        {
          value: null,
          label: "Все",
        },
        {
          value: "draft",
          label: "Черновик",
        },
        {
          value: "archive",
          label: "Отправлен",
        },
        {
          value: "new",
          label: "Входящие",
        },
      ],
    }
  },
  computed: {

    titlePage() {
      return this.$route.meta.title
    },
    showPagination() {
      if (this.pagination) {
        return this.pagination.total > this.pagination.per_page;
      } else return false;
    },
    isShowVisit() {
      if (this.visitsList) {
        return (this.visitsList.length != 0)
      } else return false
    }


  },

  created() {
    this.loadVisitList(1)
    this.getDepartments()
  },
  methods: {

    loadVisitList(page = 1) {
      this.loading = true;

      let search = [];
      if (this.search.inspectionStatus)
        search.push("inspection_status:" + this.search.inspectionStatus);
      if (this.search.departmentId)
        search.push("department_id:" + this.search.departmentId);
      if (this.search.id)
        search.push("user_id:" + this.search.id);

      let params = {
        params: {
          page,
          orderBy: 'date_end',
          sortedBy: this.filters.time,
          search: search.join(";"),
          searchJoin:
              search.length > 1
                  ? "and"
                  : null,
          userPhone: this.search.phone
              ? this.search.phone.replace("+7", "").replace(/[^\d]/g, "")
              : null,
        },
      };

      this.$api.visit
          .getList('list', params)
          .then((response) => {
            this.visitsList = response.data.data;

            if (response.data.meta)
              this.pagination = response.data.meta.pagination;
          })
          .catch(() => {
            this.$notify.error({
              title: "Ошибка загрузки списка 😕",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    goVisit(visit) {
      console.log(visit)
      this.$router.push({name: "heatMarker.item", params: {id: visit.id}});
    },
    editPagination(id) {
      console.log(id);
    },
    getDepartments() {
      this.loadDepartment = true

      this.$api.department
          .getList("lite")
          .then((response) => {

            this.departmentList = [
              ...[{id: 0, title: "Все"}],
              ...response.data,
            ]

            // this.search.departmentId = response.data[0].id;

          })
          .catch((e) => {
            console.log(e)
          })
          .finally(() => {
            this.loadDepartment = false
          })
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/zebra-table.scss";

.filters {
  display: flex;
  justify-content: space-between;
  align-content: center;
  margin-top: 20px;

  &__right {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__item {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__title {
    color: #8e8e93;
    font-size: 13px;
    line-height: 16px;
    padding: 0 5px;
  }

  &__phone {
    width: 215px;
  }

  &__id {
    width: 80px;
  }

  &__department {
    width: 140px;
  }

  &__status {
    width: 110px;
  }

  &__select {
    width: 110px;
  }
}

.user-data {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  &__photo {
    height: 40px;
    margin-right: 16px;
  }

  &__info {
    min-width: 130px;
  }

  .info-user {
    &__name {
      font-size: 13px;
      line-height: 16px;
      color: #111;

      &_mini {
        font-size: 13px;
        line-height: 16px;
        color: #8E8E93;
      }
    }

    &__phone {
      margin-top: 2px;

      font-size: 13px;
      line-height: 16px;
      color: #8c8c8c;
    }
  }
}


.el-table {
  margin-top: 40px !important;
}

/deep/ .el-table {
  background: transparent;
  margin-top: 20px;

  .el-table__header th {
    background: transparent !important;
    padding: 8px 0;

    .cell {

      font-weight: 500;
      font-size: 13px;
      line-height: 16px;

      color: #8E8E93;
    }

  }

  .el-table__row td:first-child {
    border-bottom-left-radius: 6px;
    border-top-left-radius: 6px;
  }

  .el-table__row td:last-child {
    border-bottom-right-radius: 6px;
    border-top-right-radius: 6px;
  }

  tr .cell {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 13px;

    color: #111;

  }

  .el-table__body {
    border-spacing: 0 16px;

  }

  .el-table__row {
    background: #fff !important;
    height: 60px;

    cursor: pointer;
  }

}

/deep/ .el-loading-mask {
  background-color: rgba(239, 239, 244, .87) !important;
}

</style>